"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("./hamburger-menu/index"));

var _index2 = _interopRequireDefault(require("./header-link/index"));

var _reactI18nify = require("react-i18nify");

require("./page-header.scss");

var _signOutAction = _interopRequireDefault(require("./actions/sign-out-action"));

var _icon = _interopRequireDefault(require("@internet-features/icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var PageHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(PageHeader, _React$Component);

  function PageHeader() {
    _classCallCheck(this, PageHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(PageHeader).apply(this, arguments));
  }

  _createClass(PageHeader, [{
    key: "render",
    value: function render() {
      var webmailLink = "";
      var signOutLink = "";
      var hamburgerMenu = "";

      if (!this.props.hideHamburgerMenu) {
        hamburgerMenu = _react["default"].createElement(_index["default"], null);
      }

      if (this.props.showWebmailLink) {
        webmailLink = _react["default"].createElement(_index2["default"], {
          href: this.props.webmailURL,
          inNewWindow: true,
          alt: _reactI18nify.I18n.t("header.webmailHome")
        }, _react["default"].createElement(_icon["default"], {
          name: "ki-mail",
          style: {
            "width": "24px"
          },
          "aria-hidden": "true"
        }));
      }

      if (this.props.isAuthenticated) {
        signOutLink = _react["default"].createElement(_index2["default"], {
          href: "#",
          onClick: this.props.signOut
        }, _react["default"].createElement(_reactI18nify.Translate, {
          value: "signOut"
        }));
      }

      return _react["default"].createElement("nav", {
        className: "row align-items-center mx-0 bb-1-solid-secondary bg-base page-header mb-3"
      }, _react["default"].createElement("div", {
        className: "col-4"
      }, hamburgerMenu), _react["default"].createElement("div", {
        className: "col-4 text-center"
      }, _react["default"].createElement("a", {
        href: "/",
        className: "focus-outline-primary p-1"
      }, _react["default"].createElement("img", {
        className: "spectrum-logo m-0",
        alt: "Spectrum Logo",
        src: "/assets/images/spectrum-logo.svg"
      }))), _react["default"].createElement("div", {
        className: "col-4 text-right pr-3 header-links"
      }, webmailLink, _react["default"].createElement(_index2["default"], {
        href: this.props.supportURL,
        inNewWindow: true
      }, _react["default"].createElement(_reactI18nify.Translate, {
        className: "ml-1",
        value: "header.support"
      })), signOutLink));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        "hideHamburgerMenu": _propTypes["default"].bool,
        "isAuthenticated": _propTypes["default"].bool,
        "showWebmailLink": _propTypes["default"].bool,
        "signOut": _propTypes["default"].func,
        "supportURL": _propTypes["default"].string,
        "webmailURL": _propTypes["default"].string
      };
    }
  }]);

  return PageHeader;
}(_react["default"].Component);

PageHeader.contextTypes = {};

function mapStateToProps(state) {
  return {
    "hideHamburgerMenu": state.config.get("header.hideHamburgerMenu"),
    "isAuthenticated": state.auth.isAuthenticated,
    "showWebmailLink": state.config.get("header.showWebmailLink"),
    "supportURL": state.config.get("links.support"),
    "webmailURL": state.config.get("links.webmail")
  };
}

function mapDispatchToProps(dispatch) {
  return {
    "signOut": function signOut(event) {
      event.preventDefault();
      dispatch((0, _signOutAction["default"])());
    }
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PageHeader);

exports["default"] = _default;